module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "heads_1Ihead",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Onion Peelings"), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "_tx_fnref CharOverride-2"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thelema1#footnote-001"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion1"
  }, [_vm._v("The Universe is the Practical Joke of the General at the Expense of the Particular, quoth Frater Perdurabo, and laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("But those disciples nearest to him wept, seeing the Universal Sorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Those next to them laughed, seeing the Universal Joke.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Below these certain disciples wept.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Then certain laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Others next wept.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Others next laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Next others wept.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Next others laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Last came those who wept because they could not see the Joke, and those that laughed lest they should be thought not to see the Joke, and thought it safe to act like Frater Perdurabo.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("But though Frater Perdurabo laughed openly, He also at the same time wept secretly; and in himself he neither laughed nor wept.")]), _vm._v(" "), _c('p', {
    staticClass: "onion_onion2"
  }, [_vm._v("Nor did he mean what he said.")]), _vm._v(" "), _c('p', {
    staticClass: "_tx_contents"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#_idTextAnchor000"
    }
  }, [_vm._v("[contents]")])]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-001"
    }
  }, [_c('p', {
    staticClass: "_tx_fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thelema1#footnote-001-backlink"
    }
  }, [_vm._v("2. ")]), _vm._v(" Crowley, “Ch. 14: Onion Peelings,” "), _c('span', {
    staticClass: "_tx_ital"
  }, [_vm._v("The Book of Lies")]), _vm._v(", 1995.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-339e962c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thelema-1.vue
// module id = 84
// module chunks = 0